import { Components, Theme } from '@mui/material';

export const selectStyles: Components<Theme>['MuiSelect'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: '8px',
      '.MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${theme.palette.customGrey.dark}`,
        borderRadius: '8px'
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: theme.palette.border.large.primary.main
      }
    }),
    select: {
      borderRadius: '8px',
      py: 0
    }
  },
  defaultProps: {
    MenuProps: {
      PaperProps: {
        sx: (theme: Theme) => ({
          borderRadius: '8px',
          marginTop: 0,
          border: `1px solid ${theme.palette.customGrey.dark}`
        })
      }
    }
  }
};
